import React from "react";
import "./Switch.scss";

export default function Switch({ checked, name, onChange }) {
    // Normalize incoming value to boolean for UI
    const isChecked = checked === 1 || checked === "1" || checked === true;

    return (
        <div className="position-relative ultimate-security-switcher">
            <label>
                <input
                    data-checked={isChecked}
                    name={name}
                    type="checkbox"
                    checked={isChecked}
                    onChange={(e) => {
                        // Always send 1 or 0 as integers to match DB
                        onChange(name, e.target.checked ? 1 : 0);
                    }}
                />
                <em data-on="Active" data-off="Inactive"></em>
                <span></span>
            </label>
        </div>
    );
}



